import React from 'react';
import CategoryDetail from '../components/CategoryDetail';
import { translator } from '../helpers/translator';


export function Category({ items, lang }) {
    const sectionTitle =  translator('link', lang);
    if (!items.length) return null;
    return (<CategoryDetail items={items} title={sectionTitle}></CategoryDetail>)
}